import { type AppManifest, PageActionsType } from '@wix/platform-editor-sdk';
import type { TranslationFunction } from 'i18next';

import { shouldEnableUnifiedManager } from '../../../../../utils/experiments';
import { MembersAreaEvent } from '../../../types';

type PageActions = NonNullable<AppManifest['pages']>['pageActions'];

export const getPageActions = async (t: TranslationFunction): Promise<PageActions> => {
  const renameAction = { type: PageActionsType.RENAME };

  const deleteAction = {
    title: t('Pages_Panel_MemberMenu_Actions_Page_Delete'),
    icon: 'deleteAction',
    event: MembersAreaEvent.RemovePage,
  };

  const unifiedManagerAction = {
    title: t('UnifiedManagerPanel_EntryPoint_V3_PageMoreActions'),
    icon: 'memberAction',
    event: MembersAreaEvent.OpenUnifiedManager,
  };

  const shouldShowUnifiedManagerAction = await shouldEnableUnifiedManager();

  return {
    default: [...(shouldShowUnifiedManagerAction ? [unifiedManagerAction] : [])],
    profile: [...(shouldShowUnifiedManagerAction ? [unifiedManagerAction] : []), deleteAction],
    standalone: [...(shouldShowUnifiedManagerAction ? [unifiedManagerAction] : []), deleteAction],
    custom: [...(shouldShowUnifiedManagerAction ? [unifiedManagerAction] : []), renameAction, deleteAction],
    lightbox: [],
  };
};
